import axios from 'axios';
import { qpOpenModal, qpClosemodal } from "../utils/misc";
import { toast } from "react-toastify";

const actionTypes = {
    GET_SHIPMENT_REQUEST: 'GET_SHIPMENT_REQUEST',
    GET_SHIPMENT_RESPONSE: 'GET_SHIPMENT_RESPONSE',
    GET_INVOICE_AMOUNTS: 'GET_INVOICE_AMOUNTS',
    SET_SELECTED_SHIPMENT: 'SET_SELECTED_SHIPMENT',
    OPEN_INVOICE_MODAL: 'OPEN_INVOICE_MODAL',
    OPEN_DOCUMENTS_MODAL_REQUEST: 'OPEN_DOCUMENTS_MODAL_REQUEST',
    OPEN_DOCUMENTS_MODAL_RESPONSE: 'OPEN_DOCUMENTS_MODAL_RESPONSE',
    CLOSE_MODAL: 'CLOSE_MODAL',
    READY_FOR_PICKUP_REQUEST: 'READY_FOR_PICKUP_REQUEST',
    READY_FOR_PICKUP_RESPONSE: 'READY_FOR_PICKUP_RESPONSE'
};

export const getShipments = (activeTab, pageIndex, maxRows, searchTerm) => (dispatch, getState) => {
    const requestAction = {
        type: actionTypes.GET_SHIPMENT_REQUEST
    };

    dispatch(requestAction);

    axios(`api/Shipment/GetShipments?activeTab=${activeTab}&pageIndex=${pageIndex}&maxRows=${maxRows}&searchTerm=${searchTerm}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getState().account.user.token
        }
    }).then(response => {

        var counts = getState().shipmentData.counts;

        if (counts) {
            counts[activeTab] = response.data.shipmentCount;
        }

        const responseAction = {
            type: actionTypes.GET_SHIPMENT_RESPONSE,
            payload: {
                list: response.data.shipments,
                shipmentsTab: activeTab,
                shipmentsPageIndex: pageIndex,
                showingMax: maxRows,
                searchText: searchTerm,
                counts: counts
            }
        };
        dispatch(responseAction);
    });
};

export const closeModal = () => dispatch => {
    dispatch({
        type: actionTypes.CLOSE_MODAL
    });
};

export const getDocuments = (deliveryContainerId, orderNumber) => (dispatch, getState) => {
    dispatch({ type: actionTypes.OPEN_DOCUMENTS_MODAL_REQUEST });

    axios(`api/Shipment/GetDocuments?id=${deliveryContainerId}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getState().account.user.token
        }
    }).then(response => {

        qpOpenModal('#shipmentModal');

        const responseAction = {
            type: actionTypes.OPEN_DOCUMENTS_MODAL_RESPONSE,
            payload: {
                documents: response.data,
                orderNumber: orderNumber
            }
        };
        dispatch(responseAction);
    });
};
export const setReadyForPickUp = (state) => (dispatch, getState) => {
    dispatch({ type: actionTypes.READY_FOR_PICKUP_REQUEST });
    axios(`api/Shipment/SetReadyForPickUp`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getState().account.user.token
        },
        data: JSON.stringify(state)
    }).then(response => {
        qpClosemodal('#shipmentreadyForPickuP');
        if (response.data.status === 200) {
            dispatch({ type: actionTypes.READY_FOR_PICKUP_RESPONSE });
            toast.success('Container appointment recorded', {
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        } else {
            toast.error(response.data.message, {
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        }
    });
};


// WEBPACK FOOTER //
// ./src/actions/ShipmentAction.js